// extracted by mini-css-extract-plugin
export var aircallIframe = "_fm-3";
export var fabContainer = "_fm-5";
export var fabRinging = "_fm-6";
export var loadingOverlay = "_fm-4";
export var pulse = "_fm-7";
export var widgetContent = "_fm-2";
export var widgetPanel = "_fm-0";
export var widgetPanelExpanded = "_fm-1";